
import { Vue, Options } from "vue-class-component";
import axios from "axios";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};

const dateFormatter = (date: string) => {
  let d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

@Options({
    props: {
        newTicket: {
            type: Object,
            required: false,
            default: null
        }
    },
    mounted() {
        this.$store.dispatch('Booking/getTickets');
        axios
        .get("https://bookinga.herokuapp.com/api/v1/ticket/unused", config)
            .then((res) => {
                if(res.data.ticket == undefined){
                    this.text = res.data.message
                }
                else{
                this.unused = res.data.ticket;
                for(let i=0;i<this.unused.length;i++){
                    this.unused[i].date = dateFormatter(this.unused[i].date);
                }
                let zeroticket = document.querySelector(".zero-ticket")
                zeroticket?.setAttribute("hidden","true")
                }
            });

            let loadingNewTicketInter = setInterval(() => {
                if (this.newTicket != null && this.newTicket != undefined) {
                    this.unused.unshift(this.newTicket);
                    let zeroticket = document.querySelector(".zero-ticket")
                    zeroticket?.setAttribute("hidden","true")
                    clearInterval(loadingNewTicketInter);
                }
            })
    },
})
export default class Validtickets extends Vue {
  data() {
    return {
      unused: [],
      text: ""
    };
  }
}
